import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { KnowledgeGapInsightDetailComponent } from './knowledge-gap-insight-detail/knowledge-gap-insight-detail.component';
import { KnowledgeGapTopicDetailComponent } from './knowledge-gap-topic-detail/knowledge-gap-topic-detail.component';
import { KnowledgeGapsTenantInsightsComponent } from './knowledge-gaps-tenant-insights/knowledge-gaps-tenant-insights.component';
import { SuperAdminKnowledgeGapsTenantSelectionComponent } from './super-admin-knowledge-gaps-tenant-selection.component';

const routes: Routes = [
  {
    path: '',
    component: SuperAdminKnowledgeGapsTenantSelectionComponent,
  },
  {
    path: ':tenantId',
    component: KnowledgeGapsTenantInsightsComponent,
  },
  {
    path: ':tenantId/insights/:insightId',
    component: KnowledgeGapInsightDetailComponent,
  },
  {
    path: ':tenantId/topics/:topicId',
    component: KnowledgeGapTopicDetailComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SuperAdminKnowledgeGapsRoutingModule {}
